export const navlinks = [
    { label: "Home", url: "/" },
    { label: "Submit your Idea", url: "/submit" },
  ];
export default navlinks;